"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var material_1 = require("@mui/material");
var useIsSmallScreen_1 = __importDefault(require("@/frontend/react/hooks/useIsSmallScreen"));
var Line_1 = __importDefault(require("@/frontend/react/components/Line"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var useIsMobileFullScreen_1 = __importDefault(require("@/frontend/react/hooks/useIsMobileFullScreen"));
var NotificationContext_1 = __importDefault(require("@/frontend/react/context/NotificationContext"));
var AppLayout_1 = require("../AppLayout");
var classes = {
    buttonGroup: {
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        marginBottom: 2,
        paddingTop: 4,
        paddingLeft: { xs: 3, md: 0 },
    },
    button: {
        color: 'black',
        textTransform: 'none',
        fontWeight: 'bold',
        fontSize: '18px',
        '&.active': {
            color: 'primary.main',
            backgroundColor: 'white',
            borderRadius: '50px',
            padding: '0.5rem',
            border: '1px solid',
            borderColor: 'primary.main',
        },
    },
};
function ConnectionsPage() {
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var isMobileFullScreen = (0, useIsMobileFullScreen_1.default)();
    var notifications = (0, react_1.useContext)(NotificationContext_1.default).notifications;
    var chatBadgeCount = (0, react_1.useMemo)(function () {
        var count = 0;
        Object.keys(notifications.conversations).forEach(function (key) {
            count += notifications.conversations[key];
        });
        return count;
    }, [notifications.conversations]);
    var inviteLength = Object.keys(notifications.invitations).length;
    var invitationBadgeCount = (0, react_1.useMemo)(function () {
        var count = 0;
        if (inviteLength === 0) {
            return count;
        }
        Object.keys(notifications.invitations).forEach(function (key) {
            count += notifications.invitations[key];
        });
        return count;
    }, [inviteLength, notifications.invitations]);
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ display: "flex", container: true, spacing: 5, sx: __assign(__assign({}, AppLayout_1.appLayoutClasses.container), { marginTop: 0, marginLeft: 0, width: '100%' }) }, { children: (0, jsx_runtime_1.jsxs)(material_1.Container, __assign({ maxWidth: "lg", sx: { paddingLeft: { xs: 0, md: 3 }, paddingRight: { xs: 0, md: 3 } } }, { children: [isMobileFullScreen === false && ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.buttonGroup }, { children: [(0, jsx_runtime_1.jsx)(material_1.Badge, __assign({ color: "primary", badgeContent: chatBadgeCount, invisible: !chatBadgeCount }, { children: (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ sx: classes.button, component: react_router_dom_1.NavLink, to: "chats" }, { children: trans_1.default.get('connections.chats.tab') })) })), (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ sx: classes.button, component: react_router_dom_1.NavLink, to: "recruiters" }, { children: trans_1.default.get('connections.recruiters.tab') })), (0, jsx_runtime_1.jsx)(material_1.Badge, __assign({ color: "primary", badgeContent: invitationBadgeCount, invisible: !invitationBadgeCount }, { children: (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ sx: classes.button, component: react_router_dom_1.NavLink, to: "invites" }, { children: trans_1.default.get('connections.invites.tab') })) }))] }))), isSmallScreen === false && (0, jsx_runtime_1.jsx)(Line_1.default, {}), (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {})] })) })));
}
exports.default = ConnectionsPage;
